import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./MainPage.module.css";
import CategoryButton from "./CategoryButton/CategoryButton";
import NightShelterIcon from "@mui/icons-material/NightShelter";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import ConstructionIcon from "@mui/icons-material/Construction";
import HelpIcon from "@mui/icons-material/Help";
import Grid from "@mui/material/Grid";

function MainPage(props) {
  const navigate = useNavigate();
  return (
    <Grid
      container
      justifyContent={"space-evenly"}
      alignItems={"center"}
      className={classes.grid}
    >
      <Grid item>
        <CategoryButton
          icon={<NightShelterIcon />}
          text={"Nocľahárne"}
          onClick={() => {
            navigate("/noclaharne");
          }}
        />
      </Grid>
      <Grid item>
        <CategoryButton
          icon={<HelpIcon />}
          text={"Materiálna pomoc"}
          onClick={() => {
            navigate("/materialnapomoc");
          }}
        />
      </Grid>
      <Grid item>
        <CategoryButton
          icon={<ConstructionIcon />}
          text={"Ponuka práce"}
          onClick={() => {
            navigate("/ponukaprace");
          }}
        />
      </Grid>
      <Grid item>
        <CategoryButton
          icon={<WbSunnyIcon />}
          text={"Počasie"}
          onClick={() => {
            navigate("/pocasie");
          }}
        />
      </Grid>
    </Grid>
  );
}

export default MainPage;
